import axios from 'axios';

import { API_URL } from '../config/environment-variables';

import { } from './types';

const ENDPOINT_URL = `${API_URL}/public`;

export async function checkIfEmailAddressIsAlreadyTaken(emailAddress) {
  return axios.post(`${ENDPOINT_URL}/validation`, { email: emailAddress })
    .then(() => false)
    .catch(() => true);
}